import React, { useEffect, useRef } from "react";
import { useUserStore, useFacultyStore } from "../../stores";
import "./Coordinator.css";
import CoordinatorTable from "./CoordinatorTable";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Form from 'react-bootstrap/Form'
import { handleXhrError } from "../../utils";
const MySwal = withReactContent(Swal);
const toastOptions = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};
const Coordinator = () => {
  const user = useUserStore((state) => state.data);
  const addAllSubjects = useFacultyStore((state) => state.addAllSubjects);
  const subjects = useFacultyStore((state) => state.subjects);
  const year = user.section.year;
  const sem = user.section.sem;
  const batch = user.batch;
  const nameRef = useRef();
  const subjectRef = useRef();
  const emailRef = useRef();
  const addFaculty = useFacultyStore((state) => state.addFaculty);
  const faculties = useFacultyStore((state) => state.faculties);
  useEffect(() => {
    window.$.ajax({
      type: "get",
      url: `/api/course/subjects?branch=${user.branch}&year=${year}&sem=${sem}&batch=${batch}`,
      xhrFields: {
        withCredentials: true,
      },
      dataType: "json",
      success: (response, textStatus, request) => {
        console.log(response);
        addAllSubjects(response.subjects);

      },
      statusCode: {

        404: function () {

          toast.error("page not found", toastOptions);
        },
        400: function (res) {
          if (!res.responseJSON) {
            toast.error("Something went wrong...", toastOptions);
            return;
          }

          toast.error(res.responseJSON.message, toastOptions);
          return;
        }, 
      },
      headers: {
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "",
      },
      error: function (res, textStatus, err) {
        handleXhrError(res, textStatus, err, () => {
          // e.target.disabled = false;
        })
      },
    });
  }, []);
  const addSubjectHandle = (e) => {
    e.preventDefault();
    e.target.diabled=true;
    window.$.ajax({
      type: "post",
      url: "/api/coo/addfaculty/" + subjectRef.current.value,
      xhrFields: {
        withCredentials: true,
      },
      data: {
        email: emailRef.current.value,
        firstName: nameRef.current.value
      },
      dataType: "json",
      success: (response, textStatus, request) => {
        console.log(response);
        console.log("success")
        addFaculty(response.subject);
        MySwal.fire("Faculty successfully added");
        nameRef.current.value = "";
        emailRef.current.value = "";
        // setOpenModal((draft) => {
        //   draft.open = false;
        // });
        e.target.diabled=false;

      },
      statusCode: {

        404: function () {
          // e.target.disabled = false;
          toast.error("page not found", toastOptions);
          e.target.diabled=false;
        },
        400: function (res) {
          // e.target.disabled = false;
          if (!res.responseJSON) {
            toast.error("Something went wrong...", toastOptions);
            e.target.diabled=false;
            return;
          }

          toast.error(res.responseJSON.message, toastOptions);
          
          return;
        },
      },
      headers: {
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "",
      },
      error: function (res, textStatus, err) {
        handleXhrError(res, textStatus, err, () => {
          // e.target.disabled = false;
        })
      },
    });
  }
  const userdata = useUserStore((state) => state.data);
  return (
    <div>
      {/* <ToastContainer /> */}
      <form className=" p-4 m-0" style={{ width: "99%" }}>
        <h1 className="mainHeading">{user.section.branch.name} dept.</h1>
        <h5 className="mainHeading subheading">Add lecturers in a section</h5>
        <h3 className="mainHeading mt-4">Section - {userdata.section.name}</h3>
        <div className="row" id="addSection">
          <div className="form-group col-md-4">
            <label for="semesters" className="addSlabel">Subject</label>
            <Form.Select className="addS" ref={subjectRef}>
              {subjects.map((sub, i) => (
                <option key={i} value={sub._id}>{sub.name}</option>
              ))}
            </Form.Select>
          </div>
          <div className="form-group col-md-4">
            <label for="years" className="addSlabel">
              Name
            </label>
            <input
              ref={nameRef}
              required
              type="text"
              className="form-control addS"
              placeholder="Enter lecturer name"
            />
          </div>

          <div className="form-group col-md-4">
            <label for="semesters" className="addSlabel">
              Email
            </label>
            <input
              ref={emailRef}
              required
              type="text"
              className="form-control addS"
              placeholder="Enter email"
            />
          </div>
        </div>
        <div
          style={{ display: "flex", width: "100%", justifyContent: "center" }}
        >
          <button className="addSectionbtn col-md-4 mt-4 mb-3" onClick={addSubjectHandle}>
            Add Subject
          </button>
        </div>
      </form>
      <CoordinatorTable />
    </div>
  );
};

export default Coordinator;
